import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import NextBtn from "./nextbutton";

const StepThird = ({ handleStepChange, rate, setRate,workHistory, setWorkHistory, allWorkHistory, setAllWorkHistory}) => {
  const [active, setActive] = useState(false);
  const [addMore, setAddMore] = useState(0);
  const [value, setValue] = useState("");
  const [addMoreBtnActive, setAddMoreBtnActive] = useState(false);
  const [enterAmountSection, setEnterAmountSection] = useState(false);
  // const [workHistory, setWorkHistory] = useState({});
  // const [allWorkHistory, setAllWorkHistory] = useState([]);

  const handleclick = (value, step) => {
    console.log({ value, step });
    setEnterAmountSection(false)
    if (step === 1) {
      setRate({ rate: value, time: 'month' });
      setActive(!active);

    }
    if (step ===2) {
      setRate({ rate: value, time: 'month' });
      setActive(!active);
    }
    if (step === 3) {
      setRate({ rate: value, time: 'month' });
      setActive(!active);
    }
    if (step === 4) {
      setActive(!active);
      setEnterAmountSection(true);
    }
  };




  const handleAddMoreWork = (count, checkName) => {
    console.log('count', count)
    let copyWorkHistory = [...allWorkHistory]
    if (workHistory?.projectName) {
      if (checkName) {
        const fIndex = copyWorkHistory.findIndex((el) => el.projectName === checkName);
        if (fIndex >= 0) copyWorkHistory.splice(fIndex, 1)
      } else {
        copyWorkHistory = [...copyWorkHistory, workHistory]
      }
    }
    setAllWorkHistory(copyWorkHistory)
    if (count === 0) {
      setAddMore(count)
      setAddMoreBtnActive(false)
      return
    }
    if (count >= 1) {
      setAddMore(count)
      setAddMoreBtnActive(true)
    } else {
      setAddMore(count)

    }
  }

  const handleChangeForWorkHistory = (val) => {
    setValue(val)
    setWorkHistory({ ...workHistory, ...val })
  }

  const renderComponents = () => {
    let components = [];
    for (let i = 0; i < addMore; i++) {
      components.push(<AddMoreWork key={i} setAddMore={setAddMore} addMore={addMore} handleAddMoreWork={handleAddMoreWork} handleChangeForWorkHistory={handleChangeForWorkHistory} value={value} />);
    }
    return components;
  };

  const handleChange = (val) => {
    setValue(val)
    setRate({ ...rate, ...val })
  }

  console.log('setWorkHistory---->', workHistory);

  console.log('Test---s--s->>>>>Hello ', allWorkHistory);

  return (
    <div className='resource-step-content update-profile-3'>
      <div className='resource-content '>
        <div className='resource-step-heading'>
          <h4>Rate</h4>
          <p>Please select the project rate range you have in mind..</p>
        </div>
        <Form className='resource-form-history-content' onSubmit={() => handleStepChange(1, 25)} >
          <div className='resource-budget-content rate-budget'>
            <div className='resource-budget-box'>
              <div className='resource-radio' >
                <input type='radio' name='resource' onChange={() => handleclick('$5.000 - $10.000', '1')} />
              </div>
              <span>$5.000 - $10.000</span>
            </div>
            <div className={`resource-budget-box`}>
              <div className='resource-radio' >
                <input type='radio' name='resource' onChange={() => handleclick('$10.000 - $20.000', '2')} />
              </div>
              <span>$10.000 - $20.000</span>
            </div>
            <div className='resource-budget-box'>
              <div className='resource-radio' >
                <input type='radio' name='resource' onChange={() => handleclick('$10.000 - $20.000', '3')} />
              </div>
              <span>$20.000 - $50.000</span>
            </div>
            <div className='resource-budget-box'>
              <div className='resource-radio' >
                <input type='radio' name='resource' onChange={() => handleclick('inputBoxActive', '4')} />
              </div>
              <span>Please enter amount</span>
            </div>
          </div>
          {enterAmountSection &&
            <>
              <div className='resource-form'>
                <Form.Group className='resource-dev-input'>
                  <label>Amount</label>
                  <div className='resource-input'>
                    <Form.Control type='text' placeholder='$ 0' value={value?.rate} onChange={(e) => handleChange({ rate: e.target.value })} />
                  </div>
                </Form.Group>
                <Form.Group className='resource-dev-input'>
                  <label>Hour</label>
                  <div className='resource-input'>
                    <Form.Control type='text' placeholder='0 hr' value={value?.hour} onChange={(e) => handleChange({ hour: e.target.value })} />
                  </div>
                </Form.Group>
              </div>
              <div className='resource-form'>
                <Form.Group className='resource-dev-input'>
                  <label>Month</label>
                  <div className='resource-input'>
                    <Form.Control type='text' placeholder='0 month' value={value?.month} onChange={(e) => handleChange({ month: e.target.value })} />
                  </div>
                </Form.Group>
                <Form.Group className='resource-dev-input'>
                  <label>Year</label>
                  <div className='resource-input'>
                    <Form.Control type='text' placeholder='0 year' value={value?.year} onChange={(e) => handleChange({ year: e.target.value })} />
                  </div>
                </Form.Group>
              </div>
            </>}
          <div className='resource-form-history-content'>
            <h6>Work History</h6>
            <div className='resource-form-history'>
              {renderComponents()}
              <Button className='cta-btn' onClick={() => handleAddMoreWork(addMore + 1)}>{!addMoreBtnActive ? `+ Add Work History` : `+ Add More Work History`}</Button>
            </div>
          </div>
          <NextBtn handleStepChange={handleStepChange} />
        </Form>
      </div>
    </div>
  );
};

export default StepThird;

const AddMoreWork = ({ addMore, setAddMore, handleAddMoreWork, handleChangeForWorkHistory, value }) => {
  return (
    <div className='resource-form-history-content add-more-section'>
      <Button onClick={() => handleAddMoreWork(addMore - 1, value?.projectName)} className="remove-butn">
        Remove
      </Button>
      {/* <h6>Work History</h6> */}
      <div className='resource-form-history'>
        <div className='resource-form-date'>
          <div className='resource-dev-input'>
            <label>Start Date</label>
            <Form.Group className='resource-dev-input'>
              <input type='date' value={value?.startDate} onChange={(e) => handleChangeForWorkHistory({ startDate: e.target.value })} />
            </Form.Group>
          </div>
          <div className='resource-dev-input'>
            <label>End Date</label>
            <Form.Group className='resource-dev-input'>
              <input type='date' value={value?.endDate} onChange={(e) => handleChangeForWorkHistory({ endDate: e.target.value })} />
            </Form.Group>
          </div>
        </div>
        <Form.Group className='resource-dev-input'>
          <label>Project Name</label>
          <div className='resource-input'>
            <Form.Control type='text' placeholder='Enter Project Name' value={value?.projectName} onChange={(e) => handleChangeForWorkHistory({ projectName: e.target.value })} />
          </div>
        </Form.Group>
        <Form.Group className='resource-dev-input'>
          <textarea
            placeholder='Project Description'
            name='projectDescription'
            value={value?.projectDescription} onChange={(e) => handleChangeForWorkHistory({ projectDescription: e.target.value })}
          />
        </Form.Group>
      </div>
    </div>
  );
};
